import { Base } from 'zf-web-components';
import { useContext, useEffect, useMemo, useState, type ReactElement } from 'react';
import { validator } from 'zf-web-infra';
import { observer } from 'mobx-react-lite';
import { RootContext } from '@stores';
import { customize } from '@customize';
import type { Store } from '@stores';
import type { WatermarkProps } from './types';

function getWatermarkContent(user?: Store.UserInfo): string {
  if (user?.id == null) {
    return '';
  }

  if (validator.isPhoneNumber(user.id)) {
    return `${user.name} ${user.id.slice(-4)}`;
  }

  return `${user.name} ${user.id}`;
}

export function WatermarkComponent(props: WatermarkProps): ReactElement {
  const { user } = useContext(RootContext);
  const [pathname, setPathname] = useState(window.location.pathname);
  const content = useMemo<string>(() => getWatermarkContent(user), [user]);

  useEffect(() => {
    setPathname(window.location.pathname);
  }, []);

  if (pathname.startsWith('/login')) {
    return props.children;
  }
  // 问卷输入页面 不需要水印
  if (pathname === '/toolkit/questionnaire/input') {
    return props.children;
  }
  const query = new URLSearchParams(window.location.search);
  if (
    pathname.startsWith('/v2/analysis/fruitInspection/')
    && query.get('hideWatermark') === '1'
    && (query.get('userId')?.length ?? 0) > 0
  ) {
    return props.children;
  }

  const fontStyle = customize.invoke('laowanhui.watermark.getCustomStyle', pathname) ?? { fontSize: 12, color: 'rgba(0,0,0,.05)' };

  return (
    <Base.Watermark
      zIndex={2000}
      inherit={false}
      content={content}
      font={fontStyle}>
      {props.children}
    </Base.Watermark>
  );
}

export const Watermark = observer(WatermarkComponent);
